import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchPhaseDocuments, verifyPhaseAssessment } from 'actionCreators';
import documentShape from 'types/documentUpload';
import ReactSelect from 'react-select';
import FlexBox from 'flexbox-react';
import { visibleFor } from 'components/Auth';
import ColoredButton from 'components/ColoredButton';
import selectStyles from 'components/StyledSelect/react-select-styles.scss';
import { getMinLocalDate } from '../../../../../../../utils/dateUtils';
import S from './assessmentSelection.scss';

const VerifyButton = visibleFor('verify_document', 'phase', ({ disabled, onClick }) =>
  <ColoredButton
    className={S.actionButton}
    responsive
    color="blue"
    label="Verify Document"
    onClick={onClick}
    disabled={disabled}
  />,
);

class AssessmentSelection extends Component {
  constructor(props) {
    super(props);
    this.state = { url: '', id: '' };
  }

  componentWillMount = () => (!this.hasParentDocs() ?
    this.props.fetchPhaseDocuments(this.props.phaseId).then(this.setVerifiedDocument) :
    this.setVerifiedDocument());

  setVerifiedDocument = () => {
    const { documents, verifiedDocumentId } = this.props;
    if (!verifiedDocumentId) return;
    const doc = documents.find(d => d.id === verifiedDocumentId);
    if (!doc) return;
    this.setState({ url: doc.expiring_download_url, id: doc.id });
  }

  getDocumentLabel = (doc) => {
    const { verifiedDocumentId } = this.props;
    const VERIFIED_STRING = ' (Verified Document)';
    const verified = doc.id === verifiedDocumentId ? VERIFIED_STRING : '';
    const documentName = `${doc.document_name} ${getMinLocalDate(doc.created_at)}`;
    return `${documentName}${verified}`;
  }

  getDocOptions = () => {
    const { documents } = this.props;
    return documents
      .filter(doc => doc.document_type === 'Assessment/Refigure')
      .map(doc => ({
        label: this.getDocumentLabel(doc),
        value: doc.id,
        url: doc.expiring_download_url,
      }));
  }

  hasParentDocs = () => this.props.parentDocs.length || [] > 0;

  handleOpenDocument = () => (this.state.url ? window.open(
    this.state.url,
    '_blank',
    'toolbar=1, scrollbars=1, location=1, statusbar=0, menubar=1, resizable=1, width=900, height=900',
  ) : null)

  handleStatusChange = option => this.setState({ url: option.url, id: option.value });

  verifyDocument = () => this.props.verifyPhaseAssessment({
    verified_assessment_document_id: this.state.id,
    id: this.props.phaseId,
  });

  renderContents = () => <FlexBox justifyContent="flex-end" flexWrap="wrap">
    <ReactSelect
      autoSize={false}
      placeholder="Select Assessment/Refigure"
      onChange={this.handleStatusChange}
      options={this.getDocOptions()}
      className={`${selectStyles.prettyDropDown} ${S.wrapper}`}
      value={this.state.id}
      clearable={false}
    />
    <ColoredButton
      className={S.actionButton}
      responsive
      color="green"
      label="Open document in new window"
      onClick={this.handleOpenDocument}
      disabled={!this.state.id}
    />
    <VerifyButton
      onClick={this.verifyDocument}
      disabled={!this.state.id}
    />
  </FlexBox>;

  render = () => (this.props.cv ? this.renderContents() :
    (<div className={S.wrapper}>{this.renderContents()}</div>));
}

AssessmentSelection.defaultProps = { documents: [], parentDocs: [], cv: false };

AssessmentSelection.propTypes = {
  phaseId: PropTypes.number.isRequired,
  verifiedDocumentId: PropTypes.number,
  verifyPhaseAssessment: PropTypes.func.isRequired,
  parentDocs: PropTypes.arrayOf(documentShape),
  documents: PropTypes.arrayOf(documentShape).isRequired,
  fetchPhaseDocuments: PropTypes.func.isRequired,
  cv: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  phaseId: state.phase.details.id,
  verifiedDocumentId: state.phase.details.verified_assessment_document_id,
  documents: (ownProps.parentDocs || []).length > 0 ?
    ownProps.parentDocs : state.phase.documents.data,
});

export default connect(mapStateToProps, {
  fetchPhaseDocuments, verifyPhaseAssessment,
})(AssessmentSelection);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/components/assessmentSelection.jsx